import { FormGroup, Input } from "reactstrap"
import React from "react"
import PropTypes from "prop-types"

export const FormInput = ({
  name,
  type,
  placeholder,
  onChange,
  className,
  value,
}) => {
  return (
    <FormGroup>
      <Input
        id={name}
        placeholder={placeholder}
        name={name}
        type={type}
        onChange={onChange}
        value={value}
        className={className}
        style={loadingStyle}
      />
    </FormGroup>
  )
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
}

FormInput.defaultProps = {
  type: "text",
  className: "",
}

FormInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
}
